import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { ACTION_CLOSE_POPUP, ACTION_OPEN_POPUP } from '../actions';
import { pluginKey } from './plugin-key';
export var createPlugin = function createPlugin() {
  return new SafePlugin({
    state: {
      init: function init() {
        return {
          isOpen: false
        };
      },
      apply: function apply(tr, mediaInsertPluginState) {
        var meta = tr.getMeta(pluginKey);
        if (meta) {
          switch (meta.type) {
            case ACTION_OPEN_POPUP:
              return {
                isOpen: true
              };
            case ACTION_CLOSE_POPUP:
              return {
                isOpen: false
              };
            default:
              return mediaInsertPluginState;
          }
        } else {
          return mediaInsertPluginState;
        }
      }
    },
    key: pluginKey
  });
};